import { FC } from "react";
import { observer } from "mobx-react-lite";
import { SessionsListPageListEmpty } from "./sessions-list-page-list-empty";
import { VirtualizedItemList } from "@/components/item-list";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";

interface SessionsListPageListProps {}

export const SessionsListPageList: FC<SessionsListPageListProps> = observer(() => {
  const page = useTabPageStore("sessionsListPage");

  const handleEndReached = () => {
    if (!page.canLoadMore) return;
    page.increaseLimit();
  };

  if (page.hasNoItems) {
    return <SessionsListPageListEmpty />;
  }

  return (
    <>
      {!page.isLoading && (
        <VirtualizedItemList
          rows={page.itemRows}
          listState={page.listState}
          scrollTop={page.scrollTop}
          setScrollTop={page.setScrollTop}
          endReached={handleEndReached}
        />
      )}
    </>
  );
});
